import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PreliminaryProgress = lazyWithPreload(
  () => import('./PreliminaryProgress'),
)
